import React, { useContext, useState } from "react";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import { Dropdown } from "react-bootstrap";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../report/report.css";
import { useQuery } from "react-query";
import useDebounce from "../../constants/helpers/useDebounce";
import { getUserDetails } from "../../constants/helpers/getUserDetails";
import { PaginationContext } from "../../constants/context/PaginationProvider";
import { communication, getServerUrl } from "../../constants/apis/communication";
import { formatDateToDDMMYYYY } from "../../constants/helpers/helperFunctions";
import SelectMine from "../../commanComponents/SelectMine";
import Loader from "../../commanComponents/Loader";

export default function SapExportsListComponent() {
  const [activeFilter, setActiveFilter] = useState("LogBook");
  const { sapReportsPage, setSapReportsPage, globalSearchString } = useContext(PaginationContext);
  const debouncedSearchTerm = useDebounce(globalSearchString, 1000, setSapReportsPage);

  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");

  const { data: exportedSapFiles, isFetching } = useQuery(
    ["getAllExportedSapFilesList", sapReportsPage, debouncedSearchTerm, selectedMine, activeFilter],
    () =>
      communication?.getAllExportedSapFilesList({
        searchString: debouncedSearchTerm,
        page: sapReportsPage,
        report: activeFilter === "LogBook" ? "logbook" : activeFilter === "Equipment Maintenance" ? "equipment maintenance" : activeFilter === "Equipment Barcode" ? "equipment barcode" : "",
        mineId: selectedMine,
      }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status === "JWT_INVALID") {
          toast.error(`Failed: ${data?.data?.message}`);
        }
      },
      onError: (error) => {
        toast.error(`Failed: ${error?.message}`);
      },
    }
  );

  const filters = ["LogBook", "Equipment Maintenance", "Equipment Barcode"];

  return (
    <>
      {isFetching && <Loader />}
      <div className="pageWrapper">
        <div className="premiumFilterBar" style={{ justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
            <div style={{ display: "flex", gap: "10px", background: "#f1f5f9", padding: "4px", borderRadius: "8px" }}>
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setActiveFilter(filter)}
                  style={{
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: activeFilter === filter ? 600 : 500,
                    backgroundColor: activeFilter === filter ? "#ffffff" : "transparent",
                    color: activeFilter === filter ? "#2f3299" : "#64748b",
                    boxShadow: activeFilter === filter ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                >
                  {filter}
                </button>
              ))}
            </div>

            <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} style={{ marginRight: "10px" }} />
          </div>
        </div>

        <div className="tableWrapper comman-box-shadow" style={{ position: "relative", height: "70vh", marginTop: "20px" }}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th className="text-center col_80px">Sr. No.</th>
                <th>File Name</th>
                <th>Mine ID</th>
                <th>Date</th>
                <th className="text-center col_100px">Action</th>
              </tr>
            </thead>
            <tbody>
              {(exportedSapFiles?.data?.data || exportedSapFiles?.data?.files)?.map((ele, index) => (
                <tr key={ele._id} className={index % 2 === 0 ? "skyBlueTrBg" : ""}>
                  <td className="text-center">{index + 1}</td>
                  <td>{ele.filename || "N/A"}</td>
                  <td>{ele.mineId || "N/A"}</td>
                  <td>{formatDateToDDMMYYYY(ele.date || ele.createdAt) || "N/A"}</td>
                  <td className="text-center">
                    {ele.filePath ? (
                      <a href={`${getServerUrl()}/getFiles/${ele.filePath}`} target="_blank" rel="noreferrer" style={{ color: "#2f3299", fontWeight: "600", textDecoration: "none" }}>
                        Download
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(exportedSapFiles?.data?.data || exportedSapFiles?.data?.files)?.length && <h6 className="noDataAvailableWrapper">No Data Available</h6>}
        </div>
      </div>
    </>
  );
}
